import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/impact-ot/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/workspace/impact-ot/src/features/auth/components/forgot-password-form.tsx");
